import { render, staticRenderFns } from "./DragDropFileUploadLp.vue?vue&type=template&id=74cd2c09&scoped=true&"
import script from "./DragDropFileUploadLp.vue?vue&type=script&lang=ts&"
export * from "./DragDropFileUploadLp.vue?vue&type=script&lang=ts&"
import style0 from "./DragDropFileUploadLp.vue?vue&type=style&index=0&id=74cd2c09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cd2c09",
  null
  
)

export default component.exports